
import {
    GET_PREFERENCE_REQUEST,
    GET_PREFERENCE_SUCCESS,
    UPDATE_PREFERENCE_REQUEST,
    GET_PREFERENCE_ERROR,
    UPDATE_PREFERENCE_SUCCESS,
    UPDATE_PREFERENCE_ERROR
} from "../../Actions/EndUser/AccountPreferenceActions";
import { auth } from "../../../services";

const email = auth.getAuthUserEmail()
const initialState = {
    error: '',
    updating: false,
    getting: false,
    newsletters: [],
    email
};

export const preference = (state = initialState, action) => {
    switch (action.type) {
        case GET_PREFERENCE_REQUEST:
            return {
                ...state,
                getting: true
            };
        case GET_PREFERENCE_SUCCESS:
            return {
                ...state,
                getting: false,
                newsletters: action.payload
            }; 
        case GET_PREFERENCE_ERROR:
            return {
                ...state,
                getting: false,
                error: action.payload
            };
        case UPDATE_PREFERENCE_REQUEST:
            return {
                ...state,
                updating: true
            };
        case UPDATE_PREFERENCE_SUCCESS:
            return {
                ...state,
                updating: false,
                newsletters: action.payload
            };
        case UPDATE_PREFERENCE_ERROR:
            return {
                ...state,
                updating: false
            };
        default:
            return state;           
    }
}